const checkoutLink = "";
class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }
  async fetchCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }
  storeCart(cart) {
    localStorage.setItem("juo-cart", JSON.stringify(cart));
  }
  storedCart() {
    const cart = localStorage.getItem("juo-cart");
    return cart != null ? JSON.parse(cart) : { items: [] };
  }
  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key));
    const result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items)
    };
    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find(
        (i) => i.key == oi.key && i.quantity != oi.quantity
      );
      if (!ni)
        return;
      const quantity = ni.quantity - oi.quantity;
      const item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });
    return result;
  }
  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);
    if (changes.added.length > 0 || changes.removed.length > 0) {
      const event = new CustomEvent("cart_changed", { detail: changes });
      this.storeCart(newCart);
      window.dispatchEvent(event);
    }
  }
  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          // @ts-expect-error Incorrect typing
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}
(function() {
  const defaultButtonSelector = ".cart__blocks .submit_btn";
  const cartActionsSelector = ".cart__ctas";
  const blikButtonSelector = "#juo-go-to-checkout-with-blik";
  const myCartWatcher = new CartWatcher();
  const sellingPlansMap = /* @__PURE__ */ new Map();
  sellingPlansMap.set("690253300058", "690605949274");
  sellingPlansMap.set("690253332826", "690605982042");
  sellingPlansMap.set("690253365594", "690606014810");
  sellingPlansMap.set("690253398362", "690606047578");
  let isInitialized = false;
  async function addCheckoutLink() {
    myCartWatcher.init();
    const cart = isInitialized ? myCartWatcher.storedCart() : await myCartWatcher.fetchCart();
    const hasSellingPlan = cart.items.some(
      (item) => item.selling_plan_allocation != null
    );
    if (!hasSellingPlan) {
      return;
    }
    if (document.querySelector(blikButtonSelector) != null) {
      return;
    }
    const defaultButton = document.querySelector(
      defaultButtonSelector
    );
    if (defaultButton == null) {
      return;
    }
    const defaultCheckoutButtonWrapper = defaultButton.closest(
      cartActionsSelector
    );
    const buttonTemplate = document.getElementById("juo-blik-checkout-link");
    if (buttonTemplate == null || defaultCheckoutButtonWrapper == null) {
      return;
    }
    const buttonWrapper = document.createElement("div");
    buttonWrapper.classList.add(
      "juo-blik-checkout-link-wrapper",
      "push-btn",
      "relative",
      "w-full",
      "lg:mt-2.5"
    );
    buttonWrapper.innerHTML = buttonTemplate.innerHTML;
    defaultCheckoutButtonWrapper.parentElement.insertBefore(
      buttonWrapper,
      defaultCheckoutButtonWrapper
    );
    const blikButton = buttonWrapper.querySelector(
      "button"
    );
    if (defaultButton.disabled) {
      blikButton.disabled = true;
      blikButton.classList.add("disabled");
    }
    const defaultButtonInner = defaultButton.querySelector(
      "span"
    );
    if (defaultButtonInner != null && blikButton.dataset.ccLabel != null) {
      defaultButtonInner.innerText = blikButton.dataset.ccLabel;
    }
    blikButton.addEventListener("click", switchCart);
    isInitialized = true;
  }
  async function switchCart(e) {
    var _a;
    const defaultButton = document.querySelector(
      defaultButtonSelector
    );
    if (((_a = document.querySelector("form")) == null ? void 0 : _a.checkValidity()) === false) {
      defaultButton.click();
      return;
    }
    e.target.disabled = true;
    const cart = myCartWatcher.storedCart();
    const shouldSwitch = cart.items.some((item) => {
      if (item.selling_plan_allocation != null) {
        return sellingPlansMap.has(
          String(item.selling_plan_allocation.selling_plan.id)
        );
      }
      return false;
    });
    if (!shouldSwitch) {
      window.location.href = "/checkout";
      return;
    }
    const toAdd = cart.items.map((item) => {
      const mappedSellingPlan = item.selling_plan_allocation != null ? sellingPlansMap.get(
        String(item.selling_plan_allocation.selling_plan.id)
      ) : null;
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: {
          ...item.properties,
          ...item.selling_plan_allocation != null && mappedSellingPlan != null ? {
            _selling_plan_id: String(
              item.selling_plan_allocation.selling_plan.id
            )
          } : {}
        },
        ...item.selling_plan_allocation != null ? {
          selling_plan: mappedSellingPlan != null ? mappedSellingPlan : String(item.selling_plan_allocation.selling_plan.id)
        } : {}
      };
    });
    await fetch(window.Shopify.routes.root + "cart/clear");
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: cart.attributes,
        items: toAdd
      })
    });
    e.target.disabled = false;
    if (defaultButton != null) {
      defaultButton.click();
    } else {
      window.location.href = "/checkout";
    }
  }
  async function revertCart() {
    const cart = await myCartWatcher.fetchCart();
    const shouldSwitch = cart.items.some((item) => {
      return item.properties._selling_plan_id != null && item.properties._selling_plan_id !== "";
    });
    if (!shouldSwitch) {
      return;
    }
    for (const item of cart.items) {
      if (item.properties._selling_plan_id != null && item.properties._selling_plan_id !== "") {
        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: {
              ...item.properties,
              _selling_plan_id: ""
            },
            selling_plan: item.properties._selling_plan_id
          })
        });
      }
    }
  }
  function main() {
    if (window.Shopify != null) {
      async function init() {
        await addCheckoutLink();
        window.addEventListener("cart_changed", async () => {
          await addCheckoutLink();
        });
        await revertCart();
      }
      if (document.readyState === "complete" || document.readyState === "interactive") {
        init();
      } else {
        document.addEventListener("DOMContentLoaded", init);
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();
